module.exports = __webpack_public_path__ + "static/media/36.1b0d1555.png";